import styled, { css, keyframes } from 'styled-components';
import { rem } from '../../utils';
const placeholderShimmerKeyframe = (size) => keyframes `
  0% {
    background-position: ${rem(size * -1)} 0;
  }
  100% {
    background-position: ${rem(size)} 0;
  }
`;
export const StyledSkeleton = styled.div `
  position: relative;
  display: inline-flex;
  width: -webkit-fill-available;
  width: -moz-available;
  min-height: ${({ theme }) => rem(theme.Card.Size.Inline.height)};
  cursor: pointer;
  user-select: none;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  ${({ theme }) => css `
      background: linear-gradient(
        to right,
        ${theme.Color.Neutrals.Border} 5%,
        rgba(0, 0, 0, 0.15) 35%,
        ${theme.Color.Neutrals.Border} 65%
      );
      animation: ${placeholderShimmerKeyframe(theme.Card.Size.Inline.width)}
        1.4s linear 0s infinite normal forwards;
      background-size: ${rem(theme.Card.Size.Inline.width * 2)} 100%;
    `}
`;
//# sourceMappingURL=SkeletonCard.style.js.map